<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_iii"></a><span class="bold">Churchill as</span></h1>
<h1 class="tit2"><span class="bold">Home Secretary</span></h1>
<p class="stit1"><span class="bold">Suffragettes, Strikes and</span></p>
<p class="stit2"><span class="bold">Social Reform, 1910–1911</span></p>
<p class="author"><span class="bold">Charles Stephenson</span></p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?4bf143b9